import React from 'react';
import { Link } from 'react-router-dom';

const injectOnce = (() => {
  let done = false;
  return () => {
    if (done) return; done = true;
    const s = document.createElement('style');
    s.textContent = `
      @keyframes nfFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
      @keyframes nfGlow{0%,100%{opacity:.5}50%{opacity:.8}}
      @keyframes nfEnter{0%{opacity:0;transform:translateY(18px)}100%{opacity:1;transform:translateY(0)}}
      @keyframes nfDrift{0%,100%{transform:translate(0,0)}50%{transform:translate(20px,-15px)}}
      .nf-page{display:flex;align-items:center;justify-content:center;min-height:70vh;padding:2rem 1.25rem;position:relative}
      .nf-inner{display:flex;flex-direction:column;align-items:center;text-align:center;animation:nfEnter .6s cubic-bezier(.22,1,.36,1) both;position:relative;z-index:1}
      .nf-icon{width:80px;height:80px;border-radius:50%;background:rgba(46,232,197,.06);border:2px solid rgba(46,232,197,.1);display:flex;align-items:center;justify-content:center;margin-bottom:1.5rem;animation:nfFloat 4s ease-in-out infinite}
      .nf-num{font-size:7rem;font-weight:900;letter-spacing:-.06em;line-height:1;margin-bottom:.25rem;position:relative;background:linear-gradient(180deg,rgba(46,232,197,.15),rgba(46,232,197,.03));-webkit-background-clip:text;-webkit-text-fill-color:transparent;user-select:none}
      .nf-num::after{content:'404';position:absolute;inset:0;background:linear-gradient(180deg,var(--accent,#2ee8c5),var(--purple,#8b5cf6));-webkit-background-clip:text;-webkit-text-fill-color:transparent;opacity:.1;filter:blur(18px);z-index:-1}
      .nf-title{font-size:1.35rem;font-weight:800;letter-spacing:-.03em;margin-bottom:.45rem}
      .nf-desc{font-size:.84rem;color:var(--text-secondary,#8a8a9a);line-height:1.6;max-width:380px;margin-bottom:2rem}
      .nf-actions{display:flex;gap:.65rem;flex-wrap:wrap;justify-content:center;margin-bottom:2.25rem}
      .nf-btn{display:inline-flex;align-items:center;gap:8px;padding:.75rem 1.75rem;border-radius:14px;font-size:.82rem;font-weight:700;cursor:pointer;border:none;font-family:inherit;transition:all .25s;text-decoration:none}
      .nf-btn-go{background:var(--accent,#2ee8c5);color:#0a0a0f;box-shadow:0 4px 20px rgba(46,232,197,.2)}
      .nf-btn-go:hover{transform:translateY(-2px);box-shadow:0 6px 28px rgba(46,232,197,.3)}
      .nf-btn-alt{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:var(--text-secondary,#8a8a9a)}
      .nf-btn-alt:hover{background:rgba(255,255,255,.08);color:var(--text-primary,#e8e8ec)}
      .nf-links{display:flex;gap:1.5rem;flex-wrap:wrap;justify-content:center}
      .nf-link{font-size:.72rem;color:var(--text-muted,#55555f);text-decoration:none;transition:color .2s;display:flex;align-items:center;gap:5px}
      .nf-link:hover{color:var(--accent,#2ee8c5)}
      .nf-link svg{opacity:.5}
      .nf-orb{position:absolute;border-radius:50%;filter:blur(80px);pointer-events:none;z-index:0}
      .nf-orb-1{width:300px;height:300px;top:-15%;left:-10%;background:radial-gradient(circle,rgba(46,232,197,.06),transparent 65%);animation:nfDrift 16s ease-in-out infinite}
      .nf-orb-2{width:250px;height:250px;bottom:-10%;right:-10%;background:radial-gradient(circle,rgba(139,92,246,.05),transparent 65%);animation:nfDrift 20s ease-in-out infinite reverse}
    `;
    document.head.appendChild(s);
  };
})();

const NotFound = () => {
  injectOnce();
  return (
    <div className="nf-page">
      <div className="nf-orb nf-orb-1" />
      <div className="nf-orb nf-orb-2" />
      <div className="nf-inner">
        <div className="nf-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent,#2ee8c5)" strokeWidth="1.5">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            <line x1="8" y1="11" x2="14" y2="11"/>
          </svg>
        </div>
        <div className="nf-num">404</div>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-desc">The page you're looking for doesn't exist or has been moved. Let's get you back on track.</p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-go">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            Back to Home
          </Link>
          <Link to="/track" className="nf-btn nf-btn-alt">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            Track Order
          </Link>
        </div>
        <div className="nf-links">
          <Link to="/" className="nf-link">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>
            Home
          </Link>
          <Link to="/order-status" className="nf-link">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            Order Status
          </Link>
          <Link to="/reviews" className="nf-link">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"/></svg>
            Reviews
          </Link>
          <a href="https://discord.gg/outsourced" target="_blank" rel="noopener noreferrer" className="nf-link">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
            Discord
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
